import request from '@/api/request';
import axios from 'axios';
import * as util from '@/utils/index';
import * as Auth from '@/utils/auth';
const defaultRequest = request();
const ssoRequest =  request(process.env.REFRESH_TOKEN_URL);

export function loginByUsername (data) {
  return defaultRequest({
    url: 'tracking/login',
    method: 'post',
    data
  });
}

export function refreshToken (refreshToken) {
  let data = {
    refreshToken: refreshToken,
    clientId: Auth.getClientId()
  };
  return ssoRequest({
    url: `User/refreshtoken`,
    method: 'post',
    data
  });
}

export function getUserProfile (data) {
  return ssoRequest({
    url: `User/profile?clientId=${data}`,
    method: 'get'
  });
}

export function getInternalApp () {
  return ssoRequest({
    url: `InternalApp`,
    method: 'get'
  });
}


// WEBPACK FOOTER //
// ./src/api/user.js